import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-ind-therapeutic-claim',
  templateUrl: './ind-therapeutic-claim.component.html',
  styleUrls: ['./ind-therapeutic-claim.component.scss']
})
export class IndTherapeuticClaimComponent {
  @ViewChild('indTherapeuticClaimInput') indTherapeuticClaimInput!: ElementRef;
  therapClaimInd!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.therapClaimInd = this.currentForm.get('therapClaimInd')?.value;
  }

  public clearTherapClaimIndField() {
    this.therapClaimInd = '';
    this.currentForm.patchValue({'therapClaimInd': ''});
    this.errorCheck();
  }

  public updateTherapClaimInd(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.therapClaimInd = '';
      }
    }
    this.currentForm.patchValue({'therapClaimInd': this.therapClaimInd});
    this.errorCheck();
  }

  public cancelUpdate() {
    this.therapClaimInd = this.currentForm.get('therapClaimInd')?.value;
    this.errorCheck();
  }

  private errorCheck() {
    const targetControl = this.currentForm.get('therapClaimInd');
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
